// extracted by mini-css-extract-plugin
export var backdropBlur = "_jw-0";
export var contentCard = "_jw-5";
export var frame = "_jw-2";
export var image = "_jw-4";
export var imagePane = "_jw-3";
export var modal = "_jw-1";